module.exports = __webpack_public_path__ + "static/media/24UHCHR1.6d900594.jpg";